<template>
	<botao-tooltip icone="mdi-delete" cor="grey" texto="Excluir" @click="excluir"> </botao-tooltip>
</template>
<script>
import { actionTypes } from '@/core/constants'
import BotaoTooltip from '@/views/components/BotaoTooltip.vue'

export default {
	name: 'botao-remover-item-aditivo-apostila',
	components: {BotaoTooltip},
	props: {
		item: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			itemAditivoApostila: this.item,
		}
	},
	methods: {
		async excluir() {
			const idItemAditivoApostila = this.itemAditivoApostila.id
			await this.$store
				.dispatch(actionTypes.ITEM_ADITIVO_APOSTILA.REMOVER_ITENS_ADITIVO_APOSTILA, [idItemAditivoApostila])
				.then(() => {
					this.mostrarNotificacaoSucessoDefault()
					this.$emit('excluir')
				})
		},
	},
}
</script>
